import { render } from "./StackedLayout.vue?vue&type=template&id=cd9b3f66"
import script from "./StackedLayout.vue?vue&type=script&lang=js"
export * from "./StackedLayout.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__